<template>
  <div class="">
    <div class="row col-sm-12">
      <div class="form-group col-sm-8">
        <input
          type="number"
          placeholder="0 - 99999999"
          class="form-control "
          v-model="value"
          step="10"
          min="0"
          max="99999999"
        />
      </div>

      <div class="col-sm-4">
        <input
          type="button"
          :disabled="isLoading"
          :value="isLoading ? `Loading...` : `Submit`"
          class="btn btn-primary"
          @click="submitContractualLoad"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { showAlarm } from "../../../../utils/notification";

export default {
  name: "ElementControlInput",
  props: {
    eventKey: {
      type: String
    },
    topic: {
      type: String
    }
  },
  data: () => ({
    value: 0,
    requestParam: {
      topic: this.topic,
      payload: { setExpiry: "2021-11-30T10:03:00" }
    },
    isLoading: false
  }),
  methods: {
    showLoading(value) {
      this.isLoading = value;
    },
    submitContractualLoad() {
      if (Number.isInteger(parseInt(this.value)) == false) {
        showAlarm({ type: `warning`, message: "Valid integer is required." });
        return;
      }
      if (this.value < 1) {
        showAlarm({
          type: `warning`,
          message: "Input must be within 0 - 99999999"
        });
        return;
      }
      const HTTP = this.$httpUtils.instance;
      this.requestParam.topic = this.topic;
      this.requestParam.payload = JSON.stringify({
        [this.eventKey]: this.value
      });
      this.showLoading(true);
      HTTP.options(
        `${this.$utilConstants.IOT_BASE_URL}/event/publish/`,
        this.requestParam
      )
        .then(response => {
          console.log({ response });
          this.$emit("refresh");
          showAlarm({ type: "success", message: "Success, sent!" });
          this.showLoading(false);
          this.value = 0;
        })
        .catch(e => {
          showAlarm({
            type: "error",
            message: "Error, unable to complete action, please try again"
          });
          this.showLoading(false);
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/performance/controls/element-control-input.vue